export default "__VITE_ASSET__BTn9iKVc__"